import { find } from "lodash";

export type ValidationFn = (value: any) => string | undefined;

export const passthru: ValidationFn = value => value;
export const isRequired: ValidationFn = value =>
  !value ? "Required" : undefined;

export const composeValidators = (value: any, validations: ValidationFn[]) =>
  find(validations, validation => validation(value)) || passthru;
